import {Injectable} from '@angular/core';

import {BehaviorSubject, Observable, Subject} from 'rxjs';

import {MassActionType} from '../../+mass-data-update/bulk-update/mdu-bulk-update.interfaces';
import {ListValue} from '../hire/hire.interface';


@Injectable({
  providedIn: 'root'
})
export class WizardService {
  private copyOptionsSubject: Subject<ListValue[]> = new Subject<ListValue[]>();

  public copyOptions$: Observable<ListValue[]> = this.copyOptionsSubject.asObservable();
  public massActionType$: BehaviorSubject<MassActionType> = new BehaviorSubject<MassActionType>(null);

  public updateCopyOptionsList(value: ListValue[]) {
    this.copyOptionsSubject.next(value);
  }

  public setMassActionType(actionType: MassActionType) {
    this.massActionType$.next(actionType);
  }

  public getMassActionType(): Observable<MassActionType> {
    return this.massActionType$.asObservable();
  }
}
